// this is the core api endpiints list
const cartApiList =({checkIfIsMiniApp}) => {
    return {
        INITIAL_CART: '/agg/cart-service/ve1/cart/$cartId',
        PUT_ITEMS: '/agg/cart-service/ve1/cart/$cartId/items',
        UPSELL: '/cart-service/ve2/cart/$cartId/upsell_items',
        POST_ITEMS: '/agg/cart-service/ve1/cart/$cartId/items',
        ORDER_VALIDATION: '/order-service/ve3/orders/validations',
        GET_CART_OFFER_TNC: '/promo-service/ve1/promo/$code/tnc',
        CART_REMOVE_PROMO: `/agg/cart-service/ve1/cart/$cartId/promo/$code?includePartnerOffer=${!checkIfIsMiniApp()}`,
        ORDER_STATUS_API: '/order-service/ve3/orders/checkDuplicateOrder',
        LAST_SUCCESSFULL_PAYMENT:
        '/payment-service/ve1/payment/options/lastSuccessful',
        LAST_SUCCESSFULL_PAYMENT_NEXTGEN:
        '/payment-service/ve2/payment/options/lastSuccessful',
        LAST_SUCCESSFULL_PAYMENT_NEXTGEN_V5:
        '/payment-service/ve5/payment/options/lastSuccessful',
        BATCH_CONFIRM_ORDER_SUBMIT: '/order-service/ve4/orders/submit',
        GET_TIME_SLOT: '/locator-service/ve2/stores/$storeId?timeSlots=true',
        ADVANCE_ORDER_ODA: '/locator-service/ve2/stores/advanceorder-time',
        BATCH_CONFIRM_ORDER_SUBMIT_NEXTGEN: '/order-service/ve4/orders/submit',
        VALIDATE_CARD_DETAILS:
        '/cart-service/ve2/cart/$cartId/bin/$cardInitialDigits'
}};

const CheeseReward = ({endpoints}) => {
    return {
        GET_CHEESE_REWARD_INFO: `/${endpoints.s3Bucket}/v1/widgetcontent/potp_info`,
        GET_CHEESE_REWARD_TNC: `/${endpoints.s3Bucket}/v1/widgetcontent/potp_faq_data`,
        REGISTER_CHEESE_REWARD: `/customer-service/ve1/loyalty/register?enroll=true`,
        OPT_OUT_CHEESE_REWARD: `/customer-service/ve1/loyalty/user/opt-out`,
        ENABLED_LOYALTY: `/customer-service/ve1/loyalty/register?enroll=false`
    }
};

const menuApi = ({endpoints}) => {
    return {
        GET_MENU: `/${endpoints.s3Bucket}/v1/$storeId/menu/data`,
        GET_TOPPINGS: `/${endpoints.s3Bucket}/v1/$storeId/toppings/data`,
        SET_FAVORITES: '/customer-service/ve1/user/favourites/products',
        PICKUP_STORE_ADDRESS: '/locator-service/ve2/stores/$storeId?locality=false',
        GET_EDV: `/catalog-service/ve1/stores/$storeId/deals`, // `/${endpoints.s3Bucket}/v1/$storeId/edv/banner/menu`
        GET_EDV_OFFER: `/catalog-service/ve1/stores/$storeId/deals/$dealId`,
        GET_EDV_MIXANDMATCH: `/catalog-service/ve1/stores/$storeId/deals/all`,
        GET_LOYALTY_MENU: `/catalog-service/ve1/potp/stores/$storeId/menu`
    }
};

const globalApi = () => {
    return {
        get_favourites: '/customer-service/ve1/user/favourites/products',
        GET_PREVIOUS_ORDER: '/order-service/ve1/orders/favourites/recommendations',
        GET_ALERT: '/alert-service/ve1/alerts',
        GET_DELIVERY_INSTRUCTIONS: '/api/ve1/app-config' // USED only for deliveryInstructions
    }
};

const loginApi = () => {
    return {

        FORGOT_PASSWORD_V2: '/sso-aggregation/ve2/forgotpassword',
        FORGOT_PASSWORD_V3: '/sso-aggregation/ve3/forgotpassword',
        FORGOT_PASSWORD: '/loginhandler/forgotpassword',
        LOGIN: '/loginhandler/login',
        SEARCH_USER: '/loginhandler/searchuser',
        VALIDATE_LOGIN_OTP: '/loginhandler/validatecode',
        SOCIAL_LOGIN: '/loginhandler/sociallogin',
        REFRESH_TOKEN: '/loginhandler/refreshtoken',
        REFRESH_TOKEN_ANONYMOUS: '/loginhandler/refreshtokenanonymous',
        // WALLET_BALANCE: '/wallet-service/ve1/wallet/available_balance/$mobile',
        WALLET_SUMMARY: '/wallet-service/ve3/wallet/balance',
        WALLET_BALANCE_TRANSACTION:
        '/wallet-service/ve1/wallet/available_balance/$mobile/$transactionId',
        VALIDATE_OTP_SOCIAL_LOGIN: '/loginhandler/socialvalidatecode',
        ANONYMOUS_USER: '/loginhandler/anonymoususer',
        LOGIN_MINIAPP: '/auth-service/micro-app/ve1/$vendor/auth',
        LOYALTY_INFO: '/customer-service/ve1/loyalty/user?loyaltySync=true',
        REGISTER_LOYALTY: '/customer-service/ve1/loyalty/register?enroll=true',
        FINGERPRINT_INFO: '/sso-aggregation/ve2/finger-print'
    }
};

const homepageApi = ({endpoints}) => {
    return {
        GET_WIDGET: `/${endpoints.s3Bucket}/v1`,
        GET_LEFT_NAV: `/catalog-service/ve1/stores/$storeId/leftMenu`, // `/${endpoints.s3Bucket}/v3/leftMenu/data`,
        GET_HOME_WIDGET: `/${endpoints.s3Bucket}/v3/homePage/data`,
        GET_WIDGET_CONTENT: `/catalog-service/ve1/stores/$storeId/widget`
    }
};

const locationApi = () => {
    return {
        GET_STORE_INFO: '/locator-service/ve2/stores',
        GET_STORE_INFO_NEW: '/locator-service/ve3/stores',
        GET_CITIES: '/locator-service/ve2/cities',
        GET_CITY_STORES: '/locator-service/ve2/cities/$city/stores',
        GET_SAVED_ADDRESS: '/customer-service/ve2/user/$userId/addresses',
        GET_LOCALITY: '/locator-service/ve2/cities/$city/localities',
        GET_SUB_LOCALITY: '',
        GET_LOCALITY_ADDRESS_COMPONENT: '/locator-service/ve2/stores/$storeId',
        DELETE_ADDRESS: '/customer-service/ve2/user/addresses/$addressId',
        AUTO_COMPLETE: '/locator-service/ve2/autocomplete',
        GEOCODE_API: '/locator-service/ve2/geocode',
        GET_SELECTED_CITY_STORES_LIST: '/locator-service/ve3/stores/city/$city',
        GET_STATION_DETAILS: '/locator-service/ve3/stores/$storeId/stations/$stationId'
    }
};

const paymentPageAPI = () => {
    return {
        PAYMENT_OPTION: '/payment-service/ve1/options/default',
        PAYMENT_OPTION_NEXTGEN: '/payment-service/ve1/options/default',
        CARD_INITIAL_REQUEST: '/order-service/ve3/orders/transaction/',
        SUBMIT_ORDER: '/order-service/ve3/orders/transaction/$transactionId',
        SUBMIT_ORDER_NEXTGEN:
        '/order-service/ve3/orders/transaction/$transactionId',
        GET_COD_OTP: '/payment-service/ve1/orders/$transactionId/otp',
        GET_VOUCHER_OTP: '/order-service/ve3/evoucher/$voucherCode/reset_pin',
        REMOVE_PROMO:
        '/order-service/ve3/orders/transaction/$transactionId/promo/$promo',
        GET_PAYTM_WALLET_BALANCE: '/order-service/ve3/user/wallet/paytm/balance',
        GET_PAYTM_WALLET_BALANCE_NEXTGEN:
        '/order-service/ve4/user/wallet/paytm/balance',
        GET_WALLET_HISTORY: '/wallet-service/ve1/wallet/passbook/$mobile',
        GET_TNC_DATA: '',
        SUBMIT_REQUEST: '/order-service/ve4/orders/submit',
        PAYMENT_STATUS: '/jfl-payment-aggregator/ve1/payment/transaction-status'
    }
};

const paytmPageAPI = () => {
    return {
        GET_PAYTMFORM_OTP: '/order-service/ve3/user/wallet/paytm/link',
        GET_PAYTMFORM_OTP_NEXTGEN: '/order-service/ve4/user/wallet/paytm/link',
        PAYTMOTP_VERIFY: '/order-service/ve3/user/wallet/paytm/verify',
        PAYTMOTP_VERIFY_NEXTGEN: '/order-service/ve4/user/wallet/paytm/verify',
        PAYTM_SUBMIT_ORDER:
        '/payment-verify-service/ve3/orders/paytm_wallet/redeem',
        PAYTM_SUBMIT_ORDER_NEXTGEN:
        '/payment-verify-service/ve4/orders/paytm_wallet/redeem',
        PAYMENT_MINIAPP: '/payment-verify-service/ve3/orders/pg/paytm/submit',
        PAYMENT_MINIAPP_NEXTGEN:
        '/payment-verify-service/ve4/orders/pg/paytm/submit',
        PAYMENT_VERIFY_CHARGE_STATUS:
        '/payment-verify-service/ve3/orders/CHARGE_STATUS/paytm_pg',
        PAYMENT_VERIFY_CHARGE_STATUS_NEXTGEN:
        '/payment-verify-service/ve4/orders/CHARGE_STATUS/paytm_pg',
        PROCESS_PAYMENT:
        '/payment-verify-service/ve3/orders/paytm_pg/submit?processDirect=true',
        PROCESS_PAYMENT_NEXTGEN:
        '/payment-verify-service/ve4/orders/paytm_pg/submit?processDirect=true'
    }
};

const addressPageAPI = () => {
    return {
        SAVE_ADDRESS: '/customer-service/ve2/user/$mobNo/addresses',
        BATCH_CONFIRM: '/order-service/ve3/orders/confirm',
        CONFIRM_PICKUP: '/order-service/ve4/orders',
        UPDATE_ADDRESS: '/customer-service/ve2/user/addresses/$addressId'
    }
};
const thankyouPageApi = () => {
    return {
        ORDER_STATUS: '/order-service/ve3/orders/transaction/$transactionId',
        SEND_FEEDBACK: '/order-service/ve1/orders/feedback',
        MILESTONE_OFFER: '/promo-service/ve1/promo/milestone/$couponCode/status'
    }
};

const trackOrderApi = () => {
    return {
        TRACK_ORDER: '/tracker-service/ve2/orders',
        TRACK_ORDER_HISTORY: '/tracker-service/ve2/orders/$orderHistoryId',
        TRACK_ON_MAP: '/order-service/ve1/orders/tracker/trackOnMap'
    }
};

const trackOtherOrderApi = () => {
    return {
        RECENT_ORDER: '/order-service/ve1/orders'
    }
};

const configApi = () => {
    return {
        CONFIG_API: '/api/ve1/pwa-config'
    }
};

const worldcupPageApi = ({endpoints}) => {
    return {
        GET_WORLDCUPSLIDER: `/${endpoints.s3Bucket}/v1/widgetcontent/worldCupPizzaCategoryData`,
        GET_WORLDCUP_LEADERBOARD: '/misc-service/ve1/voteDetails/leadboard'
    }
};

const dealOffers = ({checkIfIsMiniApp}) => {
    return {
        GET_DEALOFFERS: `/agg/ve1/leftnav/store/$storeId/offers?includePartnerOffer=${!checkIfIsMiniApp()}`,
        GET_TNC: '',
        GET_CART_OFFERS: `/agg/cart-service/ve1/cart/$cartId/offers?includePartnerOffer=${!checkIfIsMiniApp()}`,
        GET_LEFTNAV_CARTOFFERS: `/agg/ve1/leftnav/store/$storeId/cart/offers?includePartnerOffer=${!checkIfIsMiniApp()}`,
        GET_COMBINED_OFFERS: `/agg/cart-service/promo/$cartId/combinedOffers?includePartnerOffer=${!checkIfIsMiniApp()}`
    }
};

const orderHistory = () => {
    return {
        GET_ORDER_HISTORY: '/order-service/ve1/orders',
        GET_FAV_ORDER: '/order-service/ve1/orders/favourites/easy',
        SAVE_FAV_ORDER: '/order-service/ve1/orders/favourites/easy/$favOrderId',
        RE_ORDER: '/order-service/ve1/orders/onePassReOrder/order/$id',
        GET_ORDER_HISTORY_TRACK: '/order-service/ve3/orders',
        GET_ORDER_DETAILS: '/order-service/ve3/orders/$orderId'
    }
};

const profile = () => {
    return {
        LOGOUT: '/loginhandler/anonymoususer',
        UPDATE_USER_DATA: '/loginhandler/updateuser'
    }
};

const irctc = ({endpoints}) => {
    return {
        IRCTC_BANNER: `/${endpoints.s3Bucket}/v1/irctc/irctc_banner_tnc`,
        LOCATOR_SERVICE_PNR: '/api/ve1/locator-service/pnr/$pnr',
        IRCTC_SAVE_ORDER: '/order-service/ve1/orders/irctc/save',
        IRCTC_VALIDATE_OTP: '/order-service/ve1/orders/irctc/validateOtp',
        IRCTC_ORDER_HISTORY: '/order-service/ve1/orders/irctc',
        IRCTC_CANCEL_ORDER: '/order-service/ve1/orders/irctc/$orderId'
    }
};

const feedbackPage = () => {
    return {
        GET_CATEGORIES: '/ucr-api/api/getIssueCategories',
        SUBMIT_FEEDBACK: '/ucr-api/api/feedbacks',
        GET_CATEGORIES_V2: '/ucr-api/api/v2/getIssueCategories',
        SUBMIT_FEEDBACK_V2: '/ucr-api/api/v3/feedbacks',
        PROCESS_FEEDBACK: '/ucr-api/api/v3/tsgStatus/$eventId'
    }
};

const userActivityTracking = () => {
    return {
        SAVE_UA_TRACKING: '/user-activity-tracking/ve/v1/savePageViewData'
    }
};
const inHouseFeedback = () => {
  return {
    GET_FEEDBACK_TEMPLATE: '/feedback-service/ve1/feedback/template',
    GET_FEEDBACK_TEMPLATE_V2: '/feedback-service/ve2/feedback/template',
    SUBMIT_INHOUSE_FEEDBACK: '/feedback-service/ve1/feedback',
    UPDATE_INHOUSE_FEEDBACK: '/feedback-service/ve1/feedback/$feedbackId',
    SUBMIT_ADDITIONAL_FEEDBACK:
      '/feedback-service/ve1/feedback/$feedbackId/additional'
  }
};

const loadWidgetsApi = () => {
    return {
        GET_WIDGET_STATIC_DATA:'/jfl-discovery-service/ve1/api/public/sites/v1/getWidgetStaticData'
    }
};

const srilankaApiRegistery = (endpoints, checkIfIsMiniApp)=>{
    return {
        ...cartApiList(endpoints, checkIfIsMiniApp),
        ...menuApi(endpoints, checkIfIsMiniApp),
        ...loginApi(endpoints, checkIfIsMiniApp),
        ...homepageApi(endpoints, checkIfIsMiniApp),
        ...globalApi(endpoints, checkIfIsMiniApp),
        ...locationApi(endpoints, checkIfIsMiniApp),
        ...paymentPageAPI(endpoints, checkIfIsMiniApp),
        ...paytmPageAPI(endpoints, checkIfIsMiniApp),
        ...addressPageAPI(endpoints, checkIfIsMiniApp),
        ...thankyouPageApi(endpoints, checkIfIsMiniApp),
        ...configApi(endpoints, checkIfIsMiniApp),
        ...trackOrderApi(endpoints, checkIfIsMiniApp),
        ...trackOtherOrderApi(endpoints, checkIfIsMiniApp),
        ...dealOffers(endpoints, checkIfIsMiniApp),
        ...orderHistory(endpoints, checkIfIsMiniApp),
        ...profile(endpoints, checkIfIsMiniApp),
        ...irctc(endpoints, checkIfIsMiniApp),
        ...worldcupPageApi(endpoints, checkIfIsMiniApp),
        ...feedbackPage(endpoints, checkIfIsMiniApp),
        ...CheeseReward(endpoints, checkIfIsMiniApp),
        ...userActivityTracking(endpoints, checkIfIsMiniApp),
        ...inHouseFeedback(endpoints, checkIfIsMiniApp ),
        ...loadWidgetsApi(endpoints, checkIfIsMiniApp )
    }
};


module.exports = srilankaApiRegistery;
